module.exports = __webpack_public_path__ + "img/16m008-06.e0c04dd1.jpg";